export default "\n<!-- Load sidebar for assign accountant page -->\n<app-sidebar></app-sidebar>\n<dashboardfooter></dashboardfooter>\n\n\n\n\n\n";